import moment from 'moment';
import { Page } from '../model/elements';
import { TaskPermissionLink } from '../model/entities';
import { syncApiAxios } from './CustomAxios';

class TaskPermissionLinkApi {
    list = async (
        page: number,
        size: number,
        sortField: string,
        sortOrder: boolean,
        taskPermissionId: number,
        searchText?: string,
    ): Promise<Page<TaskPermissionLink>> => {
        const response = await syncApiAxios.get<Page<TaskPermissionLink>>('/task-permission-links', {
            params: { page, size, sortField, sortOrder, taskPermissionId, searchText },
        });
        response.data.sort.field = sortField;
        response.data.sort.order = sortOrder;
        response.data.content.forEach((d) => {
            d.audit!.created = d.audit!.created && moment.utc(d.audit!.created).local();
            d.audit!.updated = d.audit!.updated && moment.utc(d.audit!.updated).local();
        });

        return response.data;
    };

    get = async (id: number): Promise<TaskPermissionLink> => {
        const response = await syncApiAxios.get<TaskPermissionLink>(`/task-permission-links/${id}`);
        response.data.audit!.created = response.data.audit!.created && moment.utc(response.data.audit!.created).local();
        response.data.audit!.updated = response.data.audit!.updated && moment.utc(response.data.audit!.updated).local();

        return response.data;
    };
}

const taskPermissionLinkApi: TaskPermissionLinkApi = new TaskPermissionLinkApi();
export default taskPermissionLinkApi;
